/**
 * ResourceUpdater
 * Felix Kiesewetter <info@felixkiesewetter.de>
 * v0.3.1
 * 2021-04-10
 */
export default class ResourceUpdater
{

    /**
     * ResourceUpdater constructor
     *
     * @param options
     * @returns {null}
     */
    constructor(options)
    {
        this.settings = this.setSettings(options);
        const resources = document.querySelectorAll('link[rel="stylesheet"], script[src]');
        setInterval(() => {
            for (const resource of resources) {
                const type = resource.hasAttribute('src') ? 'js' : 'css';
                const fileSrc = type === 'js' ? resource.src : resource.href;
                const fileName = fileSrc.split('?')[0].split('/')[fileSrc.split('?')[0].split('/').length - 1];
                const observe = this.settings.observe.replace('/\s/g', '').split(',');
                for (const o in observe) observe[o] = observe[o].trim();
                if (observe.indexOf(fileName) >= 0) {
                    if (this.settings.debug) {
                        console.log(`checking ${fileName} ...`);
                    }
                    const fileSrcUncached = fileSrc.split('?')[0]+'?d='+(new Date()).getTime();
                    let content = resource.content || false;
                    try {
                        const debug = this.settings.debug;
                        let req = new XMLHttpRequest();
                        req.open("GET", fileSrcUncached, true);
                        req.onload = function () {
                            if (req.status === 200) {
                                content = req.responseText;
                                if (!resource.content) {
                                    if (debug) {
                                        console.log(`set ${fileName}`);
                                    }
                                    resource.content = content;
                                }
                                else if (content.length >= 100 && content !== resource.content) {
                                    switch (type) {
                                        case 'js':
                                            if (debug) {
                                                console.log(`reload to refresh: ${fileName}`);
                                            }
                                            window.location.reload();
                                            break;
                                        default:
                                            if (debug) {
                                                console.log(`change: ${fileName}`);
                                            }
                                            resource.href = fileSrcUncached;
                                            resource.content = content;
                                            break;
                                    }
                                }
                            }
                            else return false;
                        };
                        req.send(null);
                    } catch (er) {
                        console.log(er.message);
                    }
                }
            }
        }, this.settings.interval);
    }

    /**
     * Set settings
     *
     * @param options
     * @returns {object}
     */
    setSettings(options)
    {
        const defaultSettings = {
            observe: 'Main.css',
            interval: 2000,
            debug: false
        };
        return Object.assign({}, defaultSettings, options);
    }

}
